<app-main-navbar></app-main-navbar>

<div class="container-fluid">
  <div class="row" style=" display: flex; flex-grow: 1;">
    <div class="col-12">
      <div class="main-content">
        <div class="text-container">
          <h3>Technology Trends</h3>
          <br>
          <p>
            Our tool helps you identify the best and worst investment themes of the year by analyzing the growth in innovation.
          </p>
          <p>
            <strong>
             Top Accelerating Technologies :
            </strong> These are the technologies that have shown the most year on year growth and are receiving more research and development (R&D) resources compared to the previous year. These are the areas where we expect to see the strongest performance.

            <br>
            <strong>
              Largest Declining Technologies :
            </strong>
           These are technologies in the declining stage of their lifecycle with the most patent activity. While a large amount of resources are going into established operations, in relative terms companies are decreasing resources allocated into these areas. These are the areas we’d expect the weakest performance.

          </p>


        </div>
        <!-- <div>
          <p>
            Uncover the top and flop technologies within your universe, filtering by market cap, region and time. </p>
        </div> -->
        <div class="query-container">

          <!-- <div class="dropdown">
            <button [disabled]="disableButtons$ | async" class="btn btn-secondary universe-selector-button"
              (click)="openUniverseSelector()">
              Peer Group Selection
              <span *ngIf="hasPeerGroupSelection()" class="badge bg-light text-dark ms-1">
                {{ getPeerGroupSelectionText() }}
              </span>
            </button>
          </div> -->

          <!-- Country / Market filter (commented out for now)
          <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-expanded="false" style="    font-size: 14px;"
              [disabled]="disableButtons$ | async">
              Country / Market
              <span *ngIf="(countriesControl.value?.length ?? 0) > 0" class="badge bg-light text-dark ms-1">
                {{ countriesControl.value!.length }}
              </span>
            </button>
            <div class="dropdown-menu p-3" aria-labelledby="dropdownMenuButton"
              style="width: 270px; max-height: 300px; overflow-y: auto;">
              <div *ngFor="let region of countryFilterOptions">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <input type="checkbox" [checked]="isRegionFullySelected(region)"
                      (change)="toggleRegionSelection(region)" id="{{ region.region }}-region-checkbox"
                      class="form-check-input me-2">
                    <label for="{{ region.region }}-region-checkbox" class="form-check-label">
                      {{ region.region }}
                    </label>
                  </div>
                  <button class="btn btn-sm btn-light" (click)="toggleExpand(region.region); $event.stopPropagation();">
                    <i class="bi" [ngClass]="isExpanded(region.region) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  </button>
                </div>
                <div *ngIf="isExpanded(region.region)" class="ms-3">
                  <div *ngFor="let country of region.countries" class="form-check">
                    <input type="checkbox" class="form-check-input" [id]="'country-' + country.code"
                      [checked]="(countriesControl.value ?? []).includes(country.code)"
                      (change)="toggleCountrySelection(country.code, region)">
                    <label class="form-check-label" [for]="'country-' + country.code">
                      {{ country.name }}
                    </label>
                  </div>
                </div>
                <hr class="my-2" *ngIf="region !== countryFilterOptions[countryFilterOptions.length - 1]">
              </div>
            </div>
          </div>
          -->

          <!-- <input id="endDate" class="form-control" type="date" [(ngModel)]="endDate" style="width:300px;"
            [max]="getToday()" />
          <button class="btn btn-primary search-button" (click)="handleSubmit()"
            [disabled]="disableButtons$ | async">Submit</button> -->
        </div>


        <app-idea-snapshot></app-idea-snapshot>
      </div>
    </div>
  </div>
</div>
